/* eslint-disable consistent-return */
import arrayLikeToArray from "../arrayLikeToArray/arrayLikeToArray.js"

export default function unsupportedIterableToArray(o, minLen) {
  if (!o) return
  if (typeof o === "string") return arrayLikeToArray(o, minLen)
  var n = Object.prototype.toString.call(o).slice(8, -1)
  if (n === "Object" && o.constructor) n = o.constructor.name
  if (n === "Map" || n === "Set") return Array.from(o)
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return arrayLikeToArray(o, minLen)
}
